import React, { useState } from 'react';

interface Props {
 listing_hash?: string;
 proposal_hash?: string;
 className?: string;
}

const ReportButton: React.FC<Props> = ({ listing_hash, proposal_hash, className }) => {
 const [open, setOpen] = useState(false);
 const [reason, setReason] = useState('');
 const [submitting, setSubmitting] = useState(false);
 const [done, setDone] = useState(false);

 const submit = async () => {
  if (!reason.trim()) return;
  setSubmitting(true);
  try {
   const r = await fetch('/market/reports', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ listing_hash, proposal_hash, reason }),
   });
   const j = await r.json();
   if (!r.ok || !j.success) throw new Error(j.error || '신고 실패');
   setDone(true);
   setTimeout(() => { setOpen(false); setDone(false); setReason(''); }, 1500);
  } catch (err: any) {
   alert(err.message);
  } finally {
   setSubmitting(false);
  }
 };

 return (
  <>
   <button
    onClick={() => setOpen(true)}
    className={className || 'text-xs text-gray-500 hover:text-red-600 underline'}
    title="익명으로 신고합니다"
   >🚩 신고</button>
   {open && (
    <div
     className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
     onClick={(e) => { if (e.target === e.currentTarget) setOpen(false); }}
    >
     <div className="bg-white p-3 md:p-6 max-w-md w-full">
      <h2 className="text-base font-bold mb-2">신고 (익명)</h2>
      <p className="text-xs text-gray-500 mb-2">
       관리자만 검토합니다. 신고자는 다른 사용자에게 노출되지 않습니다.
      </p>
      {done ? (
       <div className="bg-green-50 text-green-700 p-2 text-sm">신고가 접수되었습니다.</div>
      ) : (
       <>
        <textarea
         value={reason}
         onChange={(e) => setReason(e.target.value)}
         rows={4}
         placeholder="신고 사유를 자세히 적어주세요"
         className="w-full px-2 py-1 border border-gray-300 text-sm"
        />
        <div className="flex gap-2 mt-2">
         <button onClick={submit} disabled={submitting || !reason.trim()}
          className="flex-1 px-3 py-2 bg-red-500 hover:bg-red-600 text-white text-sm disabled:opacity-50">
          {submitting ? '전송 중...' : '신고하기'}
         </button>
         <button onClick={() => setOpen(false)}
          className="flex-1 px-3 py-2 bg-gray-200 text-sm">취소</button>
        </div>
       </>
      )}
     </div>
    </div>
   )}
  </>
 );
};

export default ReportButton;
